import {Button, message, Modal, Popconfirm, Radio, Select, Spin, Tooltip} from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import FileUpload_JR from '../../components/FileUpload_JR';
import { Row,Col,Form, Input } from "antd";


import {config, post, postFrom} from '../../axios';
import {
    API_ADDREPAIRSTATE,
    API_CHECKLIST,
    API_device_findList, API_GETDEVICEPEPAIRREPORTBYID,
    API_salesroom_findList
} from '../../axios/config';
import Choose from "./Choose";
import AuthButton from "../../components/AuthButton/AuthButton";
const { TextArea } = Input;
class DeviceDetail extends React.Component{
  state = {
    id: null,
    visible: false,
    dataInfo: {},
      repairReportId: 0,
    salesroomList: [],
      deviceList:[],
    dataLoading: false,
    submitLoading: false,
    data: {
        houseLayout: []
    }
  }
  open(id = null) {
    this.setState({ visible: true, id,repairReportId: id })
    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  }

  close() {
    this.setState({ visible: false ,data: {}})
    this.props.form.resetFields()
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
          <Button type="primary" onClick={this.handleSubmit.bind(this)} loading={this.state.submitLoading}>保存</Button>
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }
  postSalesroomList() {
    post({ url: API_salesroom_findList }).then(res =>{
      this.setState({ salesroomList: res })
    })
  }
    postDeviceList() {
        post({ url: API_device_findList }).then(res =>{
            this.setState({ deviceList: res })
        })
    }
  postHouseTypeSubmit(data) {
    const url =  API_ADDREPAIRSTATE
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
       // this.setState({ submitLoading: false })
    }).finally(err => {
      this.setState({ submitLoading: false })
    })
  }
  postHouseTypeGet(id) {
    this.setState({ dataLoading: true,repairReportId: id })
  }
  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.repairReportId = this.state.repairReportId
        values.state = this.state.newState
      this.postHouseTypeSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: '状态变更',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 400,
      onCancel: () => this.close()
    }
  let {
      data,
  } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form
    const labelWidth = 150
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={30}>
                  <CustomRow >
                      <CustomCol labelStyle={{ width: labelWidth }} label="报修状态">
                          {getFieldDecorator('isDeviceLease', {
                              rules: [{
                                  required: true, message: '请选择处理状态',
                              }]
                          })(
                              <Radio.Group onChange={this.handleRadioDeviceLeaseChange}>
                                  <Radio value={2}>派单中</Radio>
                                  <Radio value={3}>维修中</Radio>
                                  <Radio value={4}>已完成</Radio>
                              </Radio.Group>
                          )}
                      </CustomCol>

                  </CustomRow>

                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
          <Choose
              onRef={ref => this.chooseRef = ref}
          />

      </Modal>
    )

  }
    handleRadioDeviceLeaseChange = (e) => { // 是否设备租赁
        const newState = e.target.value
        this.setState({
            newState
        })
    }

    handleChoose = () => {
        if (this.chooseRef) {
            this.chooseRef.onShow(this.state.repairReportId).then(res => {
                console.log('222');
                this.postHouseTypeGet(this.state.id);
            }).catch(() => {})
        }
    }


    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, title: "新增小区/楼栋" });
    }
}



export default Form.create({ wrappedComponentRef: true })(DeviceDetail)


// WEBPACK FOOTER //
// ./src/page/DeviceRepairReport/RepairReportState.jsx